module.exports = __webpack_public_path__ + "static/media/venti_white.9c67b6ec.svg";